/**
 * Charcoal Threads — variant swatch in-place image swap + deferred hover image.
 *
 * When a sibling swatch inside a `.ash-auto-cs` block is clicked:
 *   - prevent navigation to the sibling's product page
 *   - swap the card's primary slide image to the sibling's featured image
 *   - swap the card's hover-overlay image to the sibling's 2nd image (if any)
 *   - update the card's product link href so subsequent card-clicks go to the
 *     selected sibling
 *   - mark the clicked swatch as active
 *
 * Hover overlay uses data-src until first pointerenter/focusin so 2nd images
 * are not fetched for every card on page load.
 *
 * Uses event delegation on document so it survives infinite-scroll loads.
 * Self-guarded so the snippet can be included multiple times safely.
 */
(function () {
  if (window.__charcoalCardSwatchesInited) return;
  window.__charcoalCardSwatchesInited = true;

  function swapImage(img, src, srcset) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.src = src;
    if (srcset) img.setAttribute('srcset', srcset);
  }

  function armHoverOverlay(gallery) {
    if (!gallery) return;
    var img = gallery.querySelector('[data-charcoal-hover-overlay][data-src]');
    if (!img) return;
    var src = img.getAttribute('data-src');
    var srcset = img.getAttribute('data-srcset');
    if (!src) return;
    img.src = src;
    if (srcset) img.srcset = srcset;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }

  /* Hide Safari broken-image glyph when overlay/primary fails to load. */
  document.addEventListener(
    'error',
    function (event) {
      var t = event.target;
      if (!t || t.tagName !== 'IMG') return;
      if (
        t.classList.contains('card-gallery__hover-overlay') ||
        t.classList.contains('product-media__image')
      ) {
        t.classList.add('is-broken');
      }
    },
    true
  );

  document.addEventListener(
    'pointerenter',
    function (event) {
      var gallery = event.target && event.target.closest && event.target.closest('.card-gallery');
      if (gallery) armHoverOverlay(gallery);
    },
    true
  );
  document.addEventListener(
    'focusin',
    function (event) {
      var gallery = event.target && event.target.closest && event.target.closest('.card-gallery');
      if (gallery) armHoverOverlay(gallery);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const swatch = event.target.closest('[data-charcoal-swatch]');
      if (!swatch) return;

      const card = swatch.closest('product-card');
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();

      const primarySrc = swatch.dataset.imageSrc;
      const primarySrcset = swatch.dataset.imageSrcset;
      const secondSrc = swatch.dataset.image2Src;
      const secondSrcset = swatch.dataset.image2Srcset;
      const url = swatch.dataset.url;

      const firstSlide = card.querySelector('.card-gallery slideshow-slide');
      const primaryImg = firstSlide
        ? firstSlide.querySelector('img.product-media__image') || firstSlide.querySelector('img')
        : null;
      swapImage(primaryImg, primarySrc, primarySrcset);

      const overlayImg = card.querySelector('.card-gallery__hover-overlay');
      if (overlayImg) {
        if (secondSrc) {
          swapImage(overlayImg, secondSrc, secondSrcset);
        } else if (primarySrc) {
          swapImage(overlayImg, primarySrc, primarySrcset);
        }
      }

      if (url) {
        const productLink = card.querySelector('.product-card__link');
        if (productLink) productLink.href = url;
        const galleryLink = card.querySelector('.card-gallery [ref="cardGalleryLink"]');
        if (galleryLink) galleryLink.href = url;
      }

      card.querySelectorAll('[data-charcoal-swatch]').forEach((s) => s.classList.remove('is-current'));
      swatch.classList.add('is-current');
    },
    true
  );
})();
